import * as ko from "knockout";
import { Application } from "./application";
import { InstancesApi } from "./api/instances";

export default class InstanceManager {
    instanceId: string;
    application: Application;
    instances: InstancesApi;
    kickedOut: KnockoutObservable<boolean>;

    constructor(private app: Application) {
        // initiating
        this.application = app;
        // set ko bindable field do bind from kicked-out-overlay
        this.kickedOut = ko.observable(false);
        this.instances = app.apiManager.instances;
        // load instance id from cookie first
        this.instanceId = this.getCookie("instance");
        // check if it's wrong old version in cookie
        this.instances.getById(this.instanceId).then((data) => {
            if (data){if (!data.active){
                this.instanceId = "";
            }}
        }).then(()=>{
            // if it first start on new session request new id from api
            if (!this.instanceId)
                this.instances.getNewId().then((data) => {
                    if (data) {
                        // set instance id and store its value for other tabs
                        this.instanceId = data.sessionKey;
                        document.cookie = "instance=" + this.instanceId;
                        // initiate recheck timer for instances after id loads
                        setInterval(this.recurrentInstanceCheck.bind(this), 3000);
                    }
                });
            else
                // initiate recheck timer immediately
                setInterval(this.recurrentInstanceCheck.bind(this), 3000);
        });
    }

    recurrentInstanceCheck():void{
        this.instances.getById(this.instanceId).then((data) => {
            if (data){
                if (!data.active){
                    this.kickedOut(true);
                }
            }
        });
    }

    getCookie(name: string): string {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2)
            return parts.pop()!.split(';').shift()!;
        return "";
    }
}



// WEBPACK FOOTER //
// ./ClientApp/services/instanceManager.ts